import Component from '@glimmer/component';
import { service } from '@ember/service';
import Icon from './icon.gjs';
import { faBan, faCheck, faPlay, faStop } from '../icons/solid.js';

const icons = new Map([
  ['running', [faPlay, 'text-info']],
  ['completed', [faCheck, 'text-success']],
  ['error', [faBan, 'text-error']],
  ['canceled', [faStop, 'text-warning']],
  ['stopped', [faStop, 'text-info']],
]);

export default class TaskStatus extends Component {
  @service intl;

  get value() {
    return this.args.value?.toLowerCase();
  }

  get text() {
    return this.intl.t(`task-status.${this.value}`, {
      fallbackValue: this.args.value,
    });
  }

  get icon() {
    return icons.get(this.value)?.[0];
  }

  get iconClass() {
    return icons.get(this.value)?.[1];
  }

  <template>
    <span class="flex items-center">
      {{#if this.icon}}
        <Icon @icon={{this.icon}} @class="{{this.iconClass}} w-5 mr-1" />
      {{/if}}
      <span>{{this.text}}</span>
    </span>
  </template>
}

